import featureFlags from '@/featureFlags';
import config from '@/config'; // eslint-disable-line import/extensions

const currentConfig = {
  ...featureFlags,
  ...(config.featureFlagsOverride ?? {}),
};

export default function getFlag(key) {
  return currentConfig[key] ?? false;
}
